import { useRuntimeConfig } from '#imports'
import { type ComputedRef, computed } from 'vue'

import { useMarketplace } from '@backmarket/nuxt-module-marketplace/useMarketplace'

/**
 * Whether the Black Friday Deals pill should appear in the shopping-assistant
 * suggestion marquee.
 *
 * Backed by the `FF_SHOPPING_ASSISTANT_BLACK_FRIDAY_DEALS_ENABLED_COUNTRIES`
 * runtime feature flag — a comma-separated list of country codes, so the
 * rollout can be enabled per country without a deploy. Returns true only for
 * countries listed in the flag.
 */
export function useIsShoppingAssistantBlackFridayDealsEnabled(): ComputedRef<boolean> {
  const { market } = useMarketplace()
  const { FF_SHOPPING_ASSISTANT_BLACK_FRIDAY_DEALS_ENABLED_COUNTRIES } =
    useRuntimeConfig().public

  return computed(() => {
    return Boolean(
      FF_SHOPPING_ASSISTANT_BLACK_FRIDAY_DEALS_ENABLED_COUNTRIES?.includes(
        market.countryCode,
      ),
    )
  })
}
